import { ISector, PendingCounterApiResponse } from '../models';
import {
  LockOutlined as LockOutlinedIcon,
  LockOpen as LockOpenIcon,
} from '@mui/icons-material';

interface SectorProps {
  sector: PendingCounterApiResponse;
  selectedSector: ISector | null;
  onSelect: () => void;
  onLock: () => void;
}

export const Sector = ({
  sector,
  selectedSector,
  onSelect,
  onLock,
}: SectorProps) => {
  const isSelected = selectedSector?.id === sector.sectorId;
  const isLocked =
    selectedSector?.isLocked && selectedSector?.id === sector.sectorId;

  return (
    <div className='relative'>
      <button
        onClick={onSelect}
        className={`transition-all duration-200 cursor-pointer h-[70px] min-w-[200px] rounded-xl px-6 py-4 text-xl shadow-sm border flex items-center justify-between gap-4 ${
          isSelected
            ? 'bg-[#ff7500] text-white border-[#ff7500]'
            : 'bg-white text-[#757575] border-gray-200 hover:bg-gray-50'
        }`}
      >
        <span className='font-bold'>{sector.sectorName}</span>
        <div
          className={`w-9 h-9 rounded-full text-[16px] font-black flex items-center justify-center transition-colors duration-200 ${
            isSelected ? 'bg-white text-[#ff7500]' : 'bg-gray-100 text-gray-500'
          }`}
        >
          {sector.quantity}
        </div>
      </button>

      {isSelected && (
        <div
          className={`absolute -top-3 -right-3 z-10 rounded-full w-8 h-8 flex items-center justify-center cursor-pointer transition transform duration-200 shadow-lg ${
            isLocked
              ? 'bg-green-600 text-white ring-4 ring-green-100 scale-110'
              : 'bg-gray-100 text-gray-500 border border-gray-200'
          }`}
          onClick={onLock}
        >
          {isLocked ? (
            <LockOutlinedIcon sx={{ fontSize: 16 }} />
          ) : (
            <LockOpenIcon sx={{ fontSize: 16 }} />
          )}
        </div>
      )}
    </div>
  );
};
